export default "__VITE_ASSET__BqUEu7Bq__"